











































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductReport } from '@/interfaces/ProductReport';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';

@Component({
    name: 'AppListItem',
})
export default class AppListItem extends Vue {
    public checked = false;

    @Prop({ required: true }) protected report!: ProductReport;
    @Prop({ default: false }) protected isRemovable!: boolean;
    @Prop() protected searchKeywords!: string;

    protected get reportItem() {
        return this.report.brand ? this.report.brand : this.report;
    }

    protected get productGroup() {
        return this.$store.getters['user/activeProductGroup'];
    }

    protected get isGoodwill() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Goodwill
        );
    }

    protected get isTechnology() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Technology
        );
    }

    protected get isSoftware() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Software
        );
    }

    protected get royaltyRateOrAppropriateMargin() {
        if (!this.report) {
            return '';
        }
        let value: string;
        let valuePercentage: number;
        if (this.productGroup === ProductGroupTypes.Trademark) {
            if (
                !this.reportItem.royaltyRateReported &&
                !this.reportItem.royaltyRateCalculated
            ) {
                return '';
            }
            value = (this.reportItem.royaltyRateReported
                ? this.reportItem.royaltyRateReported
                : this.reportItem.royaltyRateCalculated
            ).replace(',', '.');
        } else if (this.productGroup === ProductGroupTypes.CustomerRelations) {
            if (!this.reportItem.customerMargin) {
                return '';
            }
            value = this.reportItem.customerMargin.replace(',', '.');
        } else if (this.productGroup === ProductGroupTypes.Goodwill) {
            if (!this.reportItem.goodwillMargin) {
                return '';
            }
            value = this.reportItem.goodwillMargin.replace(',', '.');
        } else if (this.productGroup === ProductGroupTypes.Technology) {
            if (!this.reportItem.techMarginAvgNoObs) {
                return '';
            }
            value = this.reportItem.techMarginAvgNoObs.replace(',', '.');
        }
         else if(this.productGroup===ProductGroupTypes.Software){
            if(!this.reportItem.swMarginAvgNoObs){
                return '';
            }
            value=this.reportItem.swMarginAvgNoObs.replace(',','.')
        }
        else {
            return '';
        }

        valuePercentage = parseFloat(value) * 100;
        if (valuePercentage > 0 && valuePercentage <= 2.5) {
            return '0% < x <= 2.5%';
        }
        if (valuePercentage > 2.5 && valuePercentage <= 5) {
            return '2.5% < x <= 5%';
        }
        if (valuePercentage > 5 && valuePercentage <= 10) {
            return '5% < x <= 10%';
        }
        if (
            valuePercentage > 10 &&
            valuePercentage <= 25 &&
            (this.isTechnology || this.isSoftware)
        ) {
            return '10% < x <= 25%';
        }
        if (valuePercentage > 10 && valuePercentage <= 20) {
            return '10% < x <= 20%';
        }

        if (this.isGoodwill) {
            return 'x > 20%';
        }
        if (this.isTechnology || this.isSoftware) {
            return 'x > 25%';
        }

        return '>= 20%';
    }

    protected get usdRevenuesNormalized() {
        if (this.reportItem.usdRevenues) {
            const revenueValue = Math.round(
                parseFloat(this.reportItem.usdRevenues.replace(',', '.')),
            );
            if (isNaN(revenueValue)) {
                return '';
            }
            return `USD ${revenueValue} million`;
        }
        return '';
    }

    protected handleCheckbox(value: boolean, id: number) {
        this.$emit('value-changed', { value, id });
    }

    protected openDeleteModal(idToBeDeleted: number) {
        this.$emit('open-delete-modal', idToBeDeleted);
    }
}
